import React, { useState, useEffect } from 'react';
import { api } from '../../api/api';
import { toast } from 'react-hot-toast';

const Settings = () => {
  const [returnLimit, setReturnLimit] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchReturnLimit();
  }, []);

  const fetchReturnLimit = async () => {
    try {
      const data = await api.getReturnLimit();
      console.log('Return limit response:', data);
      
      // Since the response is an array, get the latest return limit
      // Assuming the most recent limit is the last item in the array
      if (Array.isArray(data) && data.length > 0) {
        const latestLimit = data[data.length - 1];
        if (latestLimit && latestLimit.days !== undefined) {
          setReturnLimit(latestLimit.days.toString());
        } else {
          console.error('Invalid return limit data structure:', latestLimit);
          toast.error('Invalid return limit data structure');
        }
      } else {
        console.error('No return limit data found');
        toast.error('No return limit data found');
      }
    } catch (error) {
      toast.error('Failed to fetch return limit');
      console.error('Error fetching return limit:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const numericLimit = parseInt(returnLimit, 10);
      if (isNaN(numericLimit) || numericLimit < 1) {
        throw new Error('Please enter a valid number of days');
      }

      await api.updateReturnLimit(numericLimit);
      toast.success('Return limit updated successfully');
      fetchReturnLimit(); // Refresh the data
    } catch (error) {
      toast.error(error.message || 'Failed to update return limit');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-6">Settings</h1>
      
      <div className="bg-white rounded-lg shadow p-6 max-w-md">
        <h2 className="text-xl font-medium mb-4">Return Policy Settings</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label 
              htmlFor="returnLimit" 
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Return Time Limit (Days)
            </label>
            <input
              type="number"
              id="returnLimit"
              value={returnLimit}
              onChange={(e) => setReturnLimit(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              min="1"
              required
            />
          </div>
          
          <button
            type="submit"
            disabled={isLoading}
            className={`w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors
              ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {isLoading ? 'Updating...' : 'Update Return Limit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Settings;


